import React from 'react';
import axios from 'axios';
import { Button, Col, Glyphicon, Panel, Row } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Loader from 'react-loader';
import AlertDialog from '../../Shared/AlertDialog';
import WorkflowHeaderDetails from './WorkflowHeaderDetails';
import { PackageStatus } from '../../../enums/PackageStatus';
import { PackageBundleType } from '../../../enums/PackageBundleType';
import { PracticeValidationStatus } from '../../../enums/PracticeValidationStatus';
import { PackageComponentType } from '../../../enums/PackageComponentType';
import DatePicker from 'react-16-bootstrap-date-picker';
class PackageReview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            createdAlerts: [],
            alertBundle: {},
            reportBundle: {},
            alertLoadingStatus: '',
            reportLoadingStatus: '',
            selectedReports: [],
            showPackageDetailsModal: false,
            showConfirmFaxModal: false,
            loaded: false,
            faxEnabled: false,
            disEnrolledMembers: [],
            removeDisenrolledMembers: false,
            cbsReportList: [],
            alertFilterStatus: '',
            alertFilterStatusDate: '',
            alertFilterComments: '',
            queryFilterStatus: '',
            queryFilterStatusDate: '',
            queryFilterComments: '',
            selectedAlertRows: [],
            selectedQueryRows: [],            
            editStatus: { alert: '', query: '' },
            editStatusDate: { alert: '', query: '' },
            editComments: { alert: '', query: '' },
            updating: false

        };
        this.timer = null;
        this.pollingInterval = 10000;
        this.pollAlerts = true;
        this.pollBundles = true;

        const CancelToken = axios.CancelToken;
        this.source = CancelToken.source();
    }
    isViewOnly = () => {
        const { location } = this.props;
        if (
            location &&
            location.query &&
            location.query.mode === 'view'
        ) {
            return true;
        }
        if (window.location && window.location.search) {
            const params = new URLSearchParams(window.location.search);
            return params.get('mode') === 'view';
        }
        return false;
    };

    componentWillMount() {
        this.getSelectedReports();
        this.getPackageQueryList();
    }

    async componentDidMount() {
        await this.getDisenrolledMemberConfigs();
        if (this.props.provider.id) {
            this.setState({
                loaded: true
            });
        }
        this.refreshData();
    }

    componentDidUpdate(prevProps, prevState) {
        const alertStatusChanged = prevState.alertLoadingStatus !== this.state.alertLoadingStatus;
        const reportStatusChanged = prevState.reportLoadingStatus !== this.state.reportLoadingStatus;

        if (alertStatusChanged || reportStatusChanged) {
            this.getCreatedAlerts();
            this.getPackageQueryList();
            if (this.state.removeDisenrolledMembers) {
                this.getDisEnrolledMembers();
            }
        }
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.provider.id && nextProps.provider.id !== this.state.providerID) {
            this.setState({
                loaded: true
            });
        }
    }
    componentWillUnmount() {
        clearTimeout(this.timer);
        this.source.cancel();
    }
    getDisenrolledMemberConfigs = async () => {
        return axios.get('/securable/configDB', { params: { configKeys: ["RemoveDisenrolledMembers"] } })
            .then((response) => {
                if (response.data.removeDisenrolledMembers && response.data.removeDisenrolledMembers.toLowerCase() == "true") {
                    this.setState({ removeDisenrolledMembers: true });
                } else {
                    this.setState({ removeDisenrolledMembers: false });
                }
            });
    }
    getDisEnrolledMembers = () => {
        return axios.get('/packages/' + this.props.packageID + '/DisEnrolledMembers/')
            .then((response) => {
                this.setState({
                    disEnrolledMembers: response.data.items
                });
            })
            .catch((error) => {
                this.props.toast('error', 'Could not load disenrolled member data.', 'Error');
            });
    }
    // placeholder for service call to get the cbsreportlist
    getCbsReportList = () => {
        return axios.get('/packages/' + this.props.packageID + '/IncludedCBSWorkflows/')
            .then((response) => {
                this.setState({ cbsReportList: response.data });
            })
            .catch((error) => {
                this.props.toast('error', 'Could not load CBS report.', 'Error');
            });
    }

    //poll for created alerts, alert package, and report package pdfs
    refreshData = () => {
        clearTimeout(this.timer);

        if (this.pollAlerts) {
            this.getCreatedAlerts();
            if (this.state.removeDisenrolledMembers) {
                this.getDisEnrolledMembers();
            }
            if (this.props.cbsEnable) {
                this.getCbsReportList();
            }
        }
        if (this.pollBundles) {
            this.getLinks();
        }
        else {
            if (!this.state.alertLoadingStatus) {
                this.setState({ alertLoadingStatus: "Complete" });
            }
            if (!this.state.reportLoadingStatus) {
                this.setState({ reportLoadingStatus: "Complete" });
            }
        }

        if (this.pollAlerts || this.pollBundles) {
            this.timer = setTimeout(this.refreshData, this.pollingInterval);
        }
    }

    getPackageQueryList = () => {
        axios.get('/packages/' + this.props.packageID + '/IncludedQueryWorkflows')
            .then(response => {
                this.setState({ packageQueryList: response.data });
            })
            .catch((error) => {
                this.props.toast('error', 'Could not load queries.', 'Error');
            });
    }

    getSelectedReports = () => {
        axios.get('/packages/' + this.props.packageID + '/Component/', {
            cancelToken: this.source.token
        })
            .then((response) => {
                this.setState({ selectedReports: response.data });
            })
            .catch((error) => {
                this.props.toast('error', 'Could not load report selections.', 'Error');
            });
    }

    //get created alerts
    getCreatedAlerts = () => {
        Promise.all([axios.get('/packages/' + this.props.packageID), axios.get('/packages/' + this.props.packageID + '/AlertsCreated')])
            .then((response) => {
                this.getFaxEnabled(response[0].data);
                if (response[1].data.length > 0) {
                    //poll alerts until all created alerts have cdiAlertWorkflowID values
                    const noWorkflowGenerated = response[1].data.filter(x => !x.cdiAlertWorkflowID);
                    if (noWorkflowGenerated.length === 0) {
                        this.pollAlerts = false;
                    }
                }
                this.setState({ createdAlerts: response[1].data });
            })
            .catch((error) => {
                this.props.toast('error', 'Could not load created alerts.', 'Error');
            });
    }

    getFaxEnabled = (alertPackage) => {
        // If fax enabled has already been set or the package does not meet the right criteria, return
        if (this.state.faxEnabled === true || alertPackage.packageStatusID !== 'SyncCompleted' || alertPackage.includeHeaders !== true) {
            return;
        }

        Promise.all([
            axios.get('/securable/config', { params: { configKeys: ["faxEnabled"] } }),
            axios.get(`/practice/PracticeValidationInfo/${this.props.practice.groupingID}`),
            axios.get(`/packages/${this.props.packageID}/Component`),
        ])
            .then((response) => {
                if (response[0].data && Boolean(response[0].data.faxEnabled) && response[1].data && response[2].data && response[1].data.practiceValidationStatusID === PracticeValidationStatus.Accepted
                    && new Date(response[1].data.validationExpirationDate) > new Date()
                    && response[2].data.findIndex(packageComp => packageComp.packageComponentTypeID === PackageComponentType.FaxCoverSheet || packageComp.packageComponentTypeID === PackageComponentType.QueryFaxCoverSheet) >= 0) {
                    this.setState({ faxEnabled: true });
                }
            })
            .catch((error) => {
                this.props.toast('error', 'Could not load fax permissions.', 'Error');
            });
    }

    faxPackage = () => {
        // Get fax information
        axios.get(`/practice/practiceeditinfo/?practiceID=${this.props.practice.groupingID}`)
            .then((response) => {
                const faxNumber = response.data.faxNumber ? response.data.faxNumber : response.data.originalFax;
                if (!faxNumber) {
                    this.props.toast('error', 'There is no valid fax number associated with this practice.', 'Error');
                    return;
                }

                this.toggleConfirmFaxModal();

                // Create the request to fax the package
                axios.post('/faxrequests', {
                    DocumentType: 'AlertPackage',
                    DocumentEntityID: this.props.packageID,
                    FaxNumber: faxNumber,
                    FaxToName: response.data.practiceName
                })
                    .then((response) => {
                        this.props.toast('success', 'Package fax initiated.', 'Success');
                    })
                    .catch((error) => {
                        this.props.toast('error', 'Could not fax package.', 'Error');
                    });
            })
            .catch((error) => {
                this.props.toast('error', 'Could not fax package.', 'Error');
            });
    }

    //get alert package and report package bundles (includes pdf links when available)
    getLinks = () => {
        axios.get('/packages/' + this.props.packageID + '/bundles/')
            .then((response) => {
                if (response.data) {
                    response.data.bundles.forEach(bundle => {
                        if (bundle.packageBundleType === PackageBundleType.AlertPackage) {
                            if (bundle.link) {
                                this.pollBundles = false;
                                this.setState({ alertBundle: { filename: bundle.fileName, uri: bundle.link.href }, alertLoadingStatus: "Complete" });
                            }
                        }
                        else if (bundle.packageBundleType === PackageBundleType.ReportPackage) {
                            if (bundle.link) {
                                this.pollBundles = false;
                                this.setState({ reportBundle: { filename: bundle.fileName, uri: bundle.link.href }, reportLoadingStatus: "Complete" });
                            }
                        }
                    });
                    if (response.data.packageStatusID === PackageStatus.SyncingWorkflowsCompleted) {
                        this.pollBundles = false;
                        this.setState({ alertLoadingStatus: "Complete", reportLoadingStatus: "Complete" });
                    }
                }
            })
            .catch((error) => {
                this.props.toast('error', 'Could not load bundle download links.', 'Error');
            });
    }

    getPdf = (bundle) => {
        axios.get(bundle.uri.substring(bundle.uri.indexOf("/packages")), { responseType: 'arraybuffer' })
            .then((response) => {
                this.fileDownload(response.data, bundle.filename, "application/pdf");
            })
            .catch((error) => {
                this.props.toast('error', 'Could not download bundle.', 'Error');
            });
    }

    reprintPackage = () => {
        this.setState({ loaded: false });
        //check for completed alert workflows
        axios.put('/packages/' + this.props.packageID + '/Component/',
            {
                packageID: this.props.packageID,
                isReprint: true,
                checkReprintValidity: true
            }
        )
            .then((response) => {
                this.setState(
                    { loaded: true },
                    this.props.goToPackageReviewReprint
                );
            })
            .catch((error) => {
                this.setState({ loaded: true });
                this.props.toast('error', 'Cannot reprint package. An alert workflow associated with this package has already been completed.', 'Error');
            });
    }

    toggleConfirmFaxModal = () => {
        this.setState({ showConfirmFaxModal: !this.state.showConfirmFaxModal });
    }

    togglePackageDetailsModal = () => {
        this.setState({ showPackageDetailsModal: !this.state.showPackageDetailsModal });
    }

    formatDateString = (date) => {
        return date ? new Date(date).toLocaleDateString('en-US', { timeZone: 'UTC' }) : '';
    }

    formatDate = (cell) => {
        if (!cell) {
            return '';
        }
     
        const date = new Date(cell);
     
        const month = String(date.getUTCMonth() + 1).padStart(2, '0');
        const day = String(date.getUTCDate()).padStart(2, '0');
        const year = date.getUTCFullYear();
     
        return `${month}/${day}/${year}`;
    };
    renderPackageDetails = () => {
        return (
            <div>
                <h5><b>Include Blank Alerts:</b> {this.props.printOptions.includeBlankAlerts ? "Yes" : "No"}</h5>
                <h5><b>Include Headers:</b> {this.props.printOptions.includeHeaders ? "Yes" : "No"}</h5>
                <h5><b>Selected Reports:</b> {this.state.selectedReports.length === 0 ? "None" : ""}</h5>
                {
                    this.state.selectedReports.length > 0 ?
                        <ul>
                            {
                                this.state.selectedReports.sort((a, b) => {
                                    return parseInt(a.order, 10) - parseInt(b.order, 10);
                                }).map((item, index) => {
                                    return <li key={index}>{item.packageComponentTypeName}</li>
                                })
                            }
                        </ul>
                        : ""
                }
            </div>
        );
    }

    renderAlertLink = () => {
        return (
            <h4 style={{ fontSize: '16px', marginTop: '0rem', marginLeft: '1.5rem' }}>
                Alert Package:
                {this.state.alertLoadingStatus !== "Complete" ? this.renderLinkLoading() : this.renderLink(this.state.alertBundle)}
                {
                    this.isViewOnly() ||
                        this.state.alertLoadingStatus !== "Complete" ||
                        !this.state.faxEnabled
                        ? ''
                        : <Button onClick={() => this.toggleConfirmFaxModal()}>Fax</Button>
                }
            </h4>
        );
    }
    renderReportLink = () => {
        return (
            <h4 style={{ fontSize: '16px' }}>
                Report Package:
                {this.state.reportLoadingStatus !== "Complete" ? this.renderLinkLoading() : this.renderLink(this.state.reportBundle)}
            </h4>
        );
    }
    renderLink = (bundle) => {
        if (!bundle.filename || !bundle.uri) {
            return (
                <div style={{ display: 'inline-block' }}>
                    <p style={{ display: 'inline', fontSize: '16px', marginLeft: '1rem' }}>Not available</p>
                    <Button style={{ visibility: 'hidden' }}>&nbsp;</Button>
                </div>
            );
        }
        else {
            return <Button style={{ marginLeft: '1rem' }} onClick={() => this.getPdf(bundle)}>Download</Button>
        }
    }

    renderLinkLoading = () => {
        return (
            <div style={{ display: 'inline-block', paddingLeft: '1rem' }}>
                Loading
                <Glyphicon className="spinning" glyph="cog" style={{ lineHeight: "14px", color: "#6c716c", marginLeft: '0.7rem', verticalAlign: 'text-top' }} />
                <Button style={{ visibility: 'hidden' }}>&nbsp;</Button>
            </div>
        );
    }

    renderPackageDetailsButton = () => {
        return <Button onClick={this.togglePackageDetailsModal} title="View package details" style={{ marginLeft: '1rem', padding: '2px 5px' }}><Glyphicon glyph="list-alt" /></Button>
    }

    renderReprintButton = () => {
        if (this.isViewOnly()) {
            return null;
        }

        return (
            <Button
                onClick={this.reprintPackage}
                title="Reprint package"
                style={{ marginLeft: '1rem', padding: '2px 5px' }}
            >
                <Glyphicon glyph="repeat" />
            </Button>
        );
    }

    formatCDIAlertWorkflowLink = (cdiAlertWorkflowID) => {
        return <a href={'/cdi/' + cdiAlertWorkflowID + '/viewonly?isPECAddAlert=true'}>{cdiAlertWorkflowID}</a>;
    }

    sanitizeFilename = (name) =>
        name.replace(/[^a-zA-Z0-9._-]/g, '_');

    fileDownload = (data, filename, mime) => {
        const safeFilename = this.sanitizeFilename(String(filename));

        if (!/^[a-zA-Z0-9._-]+$/.test(safeFilename)) {
            this.props.toast(
                'error',
                'Unable to start download because the generated file name is invalid.',
                'Error'
            );
            return;
        }

        const blob = new Blob([data], { type: mime || 'application/octet-stream' });
        if (typeof window.navigator.msSaveBlob !== 'undefined') {
            // IE workaround for "HTML7007: One or more blob URLs were 
            // revoked by closing the blob for which they were created. 
            // These URLs will no longer resolve as the data backing 
            // the URL has been freed."
            window.navigator.msSaveBlob(blob, safeFilename);
        }
        else {
            const blobURL = window.URL.createObjectURL(blob);
            const tempLink = document.createElement('a');
            tempLink.style.display = 'none';
            tempLink.href = blobURL;

            tempLink.download = safeFilename;
            tempLink.target = '_blank';
            document.body.appendChild(tempLink);
            tempLink.click();
            document.body.removeChild(tempLink);

            window.URL.revokeObjectURL(blobURL);
        }
    }
    statusFormatter = (cell) => {
        const statusMap = {
            1: 'Delivered',
            2: 'Not Delivered',
            3: 'Blank Alert'
        };
     
        return statusMap[cell] || '';
    };
    alertStatusFormatter = (cell, row) => {
        if (this.isBlankAlert(row)) {    
            return 'Blank Alert';    
        }     
        const statusMap = {    
            1: 'Delivered',    
            2: 'Not Delivered',    
            3: 'Blank Alert'    
        };
     
        return statusMap[cell] || '';
    
    };
     

    statusDateFormatter = (cell) => {
        return cell ? this.formatDate(cell) : '';
    };

    commentsFormatter = (cell) => {
        return cell || '';
    };

    handlePackageReviewChange = (row, field, value) => {
        const updatedAlerts = this.state.createdAlerts.map(item => {
            if (item.memberID === row.memberID) {
                return {
                    ...item,
                    [field]: value
                };
            }

            return item;
        });

        const updatedQueries = (this.state.packageQueryList || []).map(item => {
            if (item.memberID === row.memberID) {
                return {
                    ...item,
                    [field]: value
                };
            }

            return item;
        });

        this.setState({
            createdAlerts: updatedAlerts,
            packageQueryList: updatedQueries
        });
    };
    isBlankAlert = (row) => {
        return row && Number(row.alertLineCount) === 0;
    };

    getSelectableAlerts = () => {
        return this.getFilteredAlerts().filter(
            row => !this.isBlankAlert(row)
        );
    };
    handleAlertRowSelect = (row, isSelected) => {
        // Blank Alert rows cannot be selected
        if (this.isBlankAlert(row)) {
            return;
        }

        let selectedRows = [...this.state.selectedAlertRows];

        if (isSelected) {
            if (!selectedRows.some(x => x.memberID === row.memberID)) {
                selectedRows.push(row);
            }
        } else {
            selectedRows = selectedRows.filter(
                x => x.memberID !== row.memberID
            );
        }

        this.setState({
            selectedAlertRows: selectedRows
        });
    };

    handleQueryRowSelect = (row, isSelected) => {
        let selectedRows = [...this.state.selectedQueryRows];

        if (isSelected) {
            if (!selectedRows.some(
                x => x.cdiAlertWorkflowID === row.cdiAlertWorkflowID
            )) {
                selectedRows.push(row);
            }
        } else {
            selectedRows = selectedRows.filter(
                x => x.cdiAlertWorkflowID !== row.cdiAlertWorkflowID
            );
        }

        this.setState({
            selectedQueryRows: selectedRows
        });
    };
    handleQueryUpdate = async () => {
        if (!this.validateUpdate('query')) {
            return;
        }
    
        const { selectedQueryRows } = this.state;
        if (!selectedQueryRows || selectedQueryRows.length === 0) {
            this.props.toast('error', 'No queries selected.', 'Error');
            return;
        }
    
        const validQueryRows = selectedQueryRows.filter(row => row.cdiAlertWorkflowID);
        if (validQueryRows.length === 0) {
            this.props.toast('error', 'No valid queries selected.', 'Error');
            return;
        }
    
        const editStatus = this.state.editStatus.query;
        const editStatusDate = this.state.editStatusDate.query;
        const editComments = this.state.editComments.query;
    
        const statusMap = {
            'Delivered': 1,
            'Not Delivered': 2,
            'Blank Alert': 3
        };
    
        const request = {
            PackageID: this.props.packageID,
            Status: statusMap[editStatus],
            StatusDate: editStatusDate,
            Comments: editStatus === 'Delivered' ? null : editComments,
            cdiAlertWorkflowIDs: validQueryRows.map(row => row.cdiAlertWorkflowID)
        };
    
        this.setState({ updating: true });
    
        try {
            // First API call: Update Query statuses
            await axios.put(
                `/packages/${this.props.packageID}/PackageQueryWorkflows`,
                request
            );
    
            const selectedIDs = validQueryRows.map(row => row.cdiAlertWorkflowID);
    
            const updatedQueries = (this.state.packageQueryList || []).map(row => {
                if (selectedIDs.includes(row.cdiAlertWorkflowID)) {
                    return {
                        ...row,
                        status: editStatus,
                        statusDate: editStatusDate,
                        comments: request.Comments
                    };
                }
                return row;
            });
    
            this.setState({
                packageQueryList: updatedQueries,
                selectedQueryRows: [],
                editStatus: { ...this.state.editStatus, query: '' },
                editStatusDate: { ...this.state.editStatusDate, query: '' },
                editComments: { ...this.state.editComments, query: '' },
                updating: false
            });
    
            // Determine the new tracking status
            const allAlerts = this.state.createdAlerts.filter(row => !this.isBlankAlert(row));
            const reviewedAlerts = allAlerts.filter(row => row.status);
    
            const allQueries = this.state.packageQueryList || [];
            const reviewedQueries = allQueries.filter(row => row.status);
    
            let trackingStatus = 'New';
            if (
                (reviewedAlerts.length > 0 && reviewedAlerts.length < allAlerts.length) ||
                (reviewedQueries.length > 0 && reviewedQueries.length < allQueries.length)
            ) {
                trackingStatus = 'InProgress';
            } else if (
                reviewedAlerts.length === allAlerts.length &&
                reviewedQueries.length === allQueries.length
            ) {
                trackingStatus = 'Completed';
            }
    
            // Second API call: Update tracking status
            await axios.put(
                `/packages/${this.props.packageID}/TrackingStatus`,
                {
                    packageID: this.props.packageID,
                    trackingStatus: trackingStatus
                }
            );
    
            this.props.toast(
                'success',
                'Changes saved successfully.',
                'Success'
            );
    
            // Refresh from server to stay in sync
            this.getPackageQueryList();
        } catch (error) {
            this.setState({ updating: false });
            this.props.toast(
                'error',
                "Changes haven't been saved. Please try again.",
                'Error'
            );
        }
    };
    handleAlertSelectAll = (isSelected) => {
        if (isSelected) {
            this.setState({
                selectedAlertRows: this.getSelectableAlerts()
            });
        } else {
            this.setState({
                selectedAlertRows: []
            });
        }
    };
    handleQuerySelectAll = (isSelected) => {
        if (isSelected) {
            this.setState({
                selectedQueryRows: this.getFilteredQueries()
            });
        } else {
            this.setState({
                selectedQueryRows: []
            });
        }
    };
    renderEditControls = (section) => {
        if (this.isViewOnly()) {
            return null;
        }
        const isAlert = section === 'alert';
        const selectedRows = isAlert
            ? this.state.selectedAlertRows
            : this.state.selectedQueryRows;
        const hasSelection = selectedRows.length > 0;

        // Pull the value for THIS section only
        const editStatus = this.state.editStatus[section];
        const editStatusDate = this.state.editStatusDate[section];
        const editComments = this.state.editComments[section];
        const isDelivered = editStatus === 'Delivered';

        return (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    gap: '12px',
                    marginBottom: '12px'
                }}
            >
                <label
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        height: '38px',
                        margin: '0',
                        padding: '0',
                        whiteSpace: 'nowrap',
                        fontWeight: 'normal',
                        lineHeight: '38px'
                    }}
                >
                    <input
                        type="checkbox"
                        checked={
                            hasSelection &&
                            selectedRows.length ===
                            (isAlert
                                ? this.getSelectableAlerts().length
                                : this.getFilteredQueries().length)
                        }
                        onChange={(e) => {
                            if (isAlert) {
                                this.handleAlertSelectAll(e.target.checked);
                            } else {
                                this.handleQuerySelectAll(e.target.checked);
                            }
                        }}
                        disabled={this.state.updating}
                        style={{
                            margin: '0 8px 0 0',
                            width: '16px',
                            height: '16px'
                        }}
                    />
                    <span>Select All</span>
                </label>

                <select
                    className="form-control"
                    value={editStatus}
                    disabled={!hasSelection || this.state.updating}
                    onChange={(e) => {
                        const status = e.target.value;
                        this.setState({
                            editStatus: { ...this.state.editStatus, [section]: status },
                            editStatusDate: {
                                ...this.state.editStatusDate,
                                [section]: status === '' ? '' : this.state.editStatusDate[section]
                            },
                            editComments: {
                                ...this.state.editComments,
                                [section]: status === 'Delivered' ? '' : this.state.editComments[section]
                            }
                        });
                    }}
                    style={{
                        width: '160px',
                        height: '38px',
                        margin: '0',
                        padding: '6px 12px'
                    }}
                >
                    <option value="">Status</option>
                    <option value="Delivered">Delivered</option>
                    <option value="Not Delivered">Not Delivered</option>
                </select>

                <div style={{ width: '160px' }}>
                    <DatePicker
                        value={editStatusDate}
                        disabled={!hasSelection || this.state.updating}
                        calendarContainer={document.body}
                        calendarPlacement="bottom"
                        onChange={(value) =>
                            this.setState({
                                editStatusDate: { ...this.state.editStatusDate, [section]: value }
                            })
                        }
                    />
                </div>

                <select
                    className="form-control"
                    value={editComments}
                    disabled={!hasSelection || isDelivered || this.state.updating}
                    onChange={(e) =>
                        this.setState({
                            editComments: { ...this.state.editComments, [section]: e.target.value }
                        })
                    }
                    style={{ width: '230px' }}
                >
                    <option value="">Comments</option>
                    <option value="Provider not at practice">Provider not at practice</option>
                    <option value="Member not at practice">Member not at practice</option>
                </select>

                <Button
                    bsStyle="primary"
                    disabled={!hasSelection || !editStatus || this.state.updating}
                    onClick={() => isAlert ? this.handlePackageReviewUpdate(section) : this.handleQueryUpdate()}
                >
                    {this.state.updating ? 'Updating...' : 'Update'}
                </Button>
            </div>
        );
    };
    validateUpdate = (section) => {
        const editStatus = this.state.editStatus[section];
        const editStatusDate = this.state.editStatusDate[section];
        const editComments = this.state.editComments[section];

        if (!editStatus) {
            this.props.toast(
                'error',
                'Please select a Status.',
                'Error'
            );
            return false;
        }

        if (
            (editStatus === 'Delivered' ||
                editStatus === 'Not Delivered') &&
            !editStatusDate
        ) {
            this.props.toast(
                'error',
                'Status Date is required.',
                'Error'
            );
            return false;
        }

        if (
            editStatus === 'Not Delivered' &&
            !editComments
        ) {
            this.props.toast(
                'error',
                'Comments are required when Status is Not Delivered.',
                'Error'
            );
            return false;
        }

        return true;
    };
    handlePackageReviewUpdate = async (section) => {
        if (!this.validateUpdate(section)) {
            return;
        }
        const selectedRows =
            section === 'alert'
                ? this.state.selectedAlertRows
                : this.state.selectedQueryRows;
        if (!selectedRows || selectedRows.length === 0) {
            return;
        }
        // Blank Alerts must never be updated
        const rowsToUpdate = selectedRows.filter(
            row => !this.isBlankAlert(row)
        );
        if (rowsToUpdate.length === 0) {
            return;
        }
        const editStatus = this.state.editStatus[section];
        const editStatusDate = this.state.editStatusDate[section];
        const editComments = this.state.editComments[section];

        const payload = {
            status: editStatus,
            statusDate: editStatusDate,
            comments: editStatus === 'Delivered' ? null : editComments
        };
        this.setState({ updating: true });
        const statusMap = {
            'Delivered': 1,
            'Not Delivered': 2,
            'Blank Alert': 3
        };
        try {
            const request = {
                packageID: this.props.packageID,
                memberIDs: rowsToUpdate.map(row => row.memberID),
                status: statusMap[editStatus],
                statusDate: editStatusDate,
                comments: editStatus === 'Delivered' ? null : editComments
            };

            // First API call: Update member statuses
            await axios.put(
                `/packages/${this.props.packageID}/Members`,
                request
            );

            // Determine the new tracking status
            const allMembers = section === 'alert' ? this.state.createdAlerts : this.state.packageQueryList;
            const applicableMembers = allMembers.filter(row => !this.isBlankAlert(row));
            const reviewedMembers = applicableMembers.filter(row => row.status);

            let trackingStatus = 'New';
            if (reviewedMembers.length > 0 && reviewedMembers.length < applicableMembers.length) {
                trackingStatus = 'InProgress';
            } else if (reviewedMembers.length === applicableMembers.length) {
                trackingStatus = 'Completed';
            }

            // Second API call: Update tracking status
            await axios.put(
                `/packages/${this.props.packageID}/TrackingStatus`,
                {
                    packageID: this.props.packageID,
                    trackingStatus: trackingStatus
                }
            );

            // Update Alerts or Queries immediately
            if (section === 'alert') {
                const selectedIDs = rowsToUpdate.map(
                    row => row.memberID
                );

                const updatedAlerts =
                    this.state.createdAlerts.map(row => {
                        if (selectedIDs.includes(row.memberID)) {
                            return {
                                ...row,
                                status: statusMap[editStatus],
                                statusDate: payload.statusDate,
                                comments: payload.comments
                            };
                        }
                        return row;
                    });
                this.setState({
                    createdAlerts: updatedAlerts,
                    selectedAlertRows: [],
                    editStatus: { ...this.state.editStatus, [section]: '' },
                    editStatusDate: { ...this.state.editStatusDate, [section]: '' },
                    editComments: { ...this.state.editComments, [section]: '' },
                    updating: false
                });
            }
            // Update Queries immediately
            else {
                const selectedIDs = rowsToUpdate.map(
                    row => row.memberID
                );
                const updatedQueries =
                    this.state.packageQueryList.map(row => {
                        if (selectedIDs.includes(row.memberID)) {
                            return {
                                ...row,
                                status: payload.status,
                                statusDate: payload.statusDate,
                                comments: payload.comments
                            };
                        }
                        return row;
                    });
                this.setState({
                    packageQueryList: updatedQueries,
                    selectedQueryRows: [],
                    editStatus: { ...this.state.editStatus, [section]: '' },
                    editStatusDate: { ...this.state.editStatusDate, [section]: '' },
                    editComments: { ...this.state.editComments, [section]: '' },
                    updating: false
                });
            }
            this.props.toast(
                'success',
                'Changes saved successfully.',
                'Success'
            );
        }
        catch (error) {
            this.setState({
                updating: false
            });
            this.props.toast(
                'error',
                "Changes haven't been saved. Please try again.",
                'Error'
            );
        }
    };

    getFilteredAlerts = () => {
        return this.state.createdAlerts.filter(item => {
            // Resolve the display status the same way the table column does
            const displayStatus = this.isBlankAlert(item) ? 'Blank Alert' : (item.status || '');

            const statusMatch =
                !this.state.alertFilterStatus ||
                displayStatus === this.state.alertFilterStatus;  // ← was: item.status === ...

            const commentsMatch =
                !this.state.alertFilterComments ||
                item.comments === this.state.alertFilterComments;
            const statusDateMatch =
                !this.state.alertFilterStatusDate ||
                (
                    item.statusDate &&
                    item.statusDate.substring(0, 10) ===
                    this.state.alertFilterStatusDate.substring(0, 10)
                );
            return statusMatch && statusDateMatch && commentsMatch;
        });
    };

    getFilteredQueries = () => {
        return (this.state.packageQueryList || []).filter(item => {
            const statusMatch =
                !this.state.queryFilterStatus ||
                item.status === this.state.queryFilterStatus;
            const commentsMatch =
                !this.state.queryFilterComments ||
                item.comments === this.state.queryFilterComments;
            const statusDateMatch =
                !this.state.queryFilterStatusDate ||
                (
                    item.statusDate &&
                    item.statusDate.substring(0, 10) ===
                    this.state.queryFilterStatusDate.substring(0, 10)
                );
            return statusMatch && statusDateMatch && commentsMatch;
        });
    };

    renderSectionFilters = (section) => {
        const isAlert = section === 'alert';

        return (
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    gap: '10px',
                    marginBottom: '10px'
                }}
            >
                <select
                    className="form-control"
                    value={
                        isAlert
                            ? this.state.alertFilterStatus
                            : this.state.queryFilterStatus
                    }

                    onChange={(e) => {
                        if (isAlert) {
                            this.setState({
                                alertFilterStatus: e.target.value,
                                selectedAlertRows: []
                            });
                        } else {
                            this.setState({
                                queryFilterStatus: e.target.value,
                                selectedQueryRows: []
                            });
                        }
                    }}

                    style={{ width: '160px' }}
                >
                    <option value="">Status</option>
                    <option value="Delivered">Delivered</option>
                    <option value="Not Delivered">Not Delivered</option>
                    <option value="Blank Alert">Blank Alert</option>
                </select>

                <DatePicker
                    value={
                        isAlert
                            ? this.state.alertFilterStatusDate
                            : this.state.queryFilterStatusDate
                    }
                    /* calendarContainer intentionally omitted — stays within .package-review-table for z-index styling */
                    calendarContainer={document.body}
                    calendarPlacement="bottom"
                    onChange={(value) => {
                        if (isAlert) {
                            this.setState({
                                alertFilterStatusDate: value,
                                selectedAlertRows: []
                            });
                        } else {
                            this.setState({
                                queryFilterStatusDate: value,
                                selectedQueryRows: []
                            });
                        }
                    }}
                />
                <select
                    className="form-control"
                    value={
                        isAlert
                            ? this.state.alertFilterComments
                            : this.state.queryFilterComments

                    }

                    onChange={(e) => {
                        if (isAlert) {
                            this.setState({
                                alertFilterComments: e.target.value,
                                selectedAlertRows: []
                            });
                        } else {
                            this.setState({
                                queryFilterComments: e.target.value,
                                selectedQueryRows: []
                            });
                        }
                    }}
                    style={{ width: '230px' }}
                >
                    <option value="">Comments</option>
                    <option value="Provider not at practice">
                        Provider not at practice
                    </option>
                    <option value="Member not at practice">

                        Member not at practice
                    </option>
                </select>
            </div>
        );
    };
    render() {
        const packageDetails = this.renderPackageDetails();
        const isPrePrint = this.props.packageType === "PrePrint";
        const tableStyle = `

        .package-review-table .react-bs-table-container,    
        .package-review-table .react-bs-table,    
        .package-review-table .react-bs-table-body {    
            overflow: visible !important;    
        }    
        .package-review-table .datepicker,    
        .package-review-table .dropdown-menu {    
            z-index: 2000 !important;    
        }    
    `;
        return (
            <div>
                <style>{tableStyle}</style>
                <Row>
                    <Col sm={9}>
                        <h3 className="workflow-title">Package Review</h3>
                        {
                            this.state.loaded &&
                            <WorkflowHeaderDetails title={"Package Review"} provider={this.props.provider.desc + ' (' + this.props.provider.id + ')'} practice={this.props.practice.desc}
                                deliveryDate={this.formatDateString(this.props.deliveryDate)} detailsButton={this.renderPackageDetailsButton()} reprintButton={this.renderReprintButton()}
                                packageType={this.props.packageType} />
                        }
                    </Col>
                    <Col sm={3}>
                        {
                            this.state.loaded &&
                            <Panel style={{ border: 'none', boxShadow: 'none', float: 'right', marginBottom: '0px', marginTop: '1.4rem', minWidth: '240px' }}>
                                {this.renderAlertLink()}
                                {this.renderReportLink()}
                            </Panel>
                        }
                    </Col>
                </Row>
                <hr style={{ marginTop: '10px', marginBottom: '10px' }} />
                <Loader loaded={this.state.loaded}>
                    <Row>
                        <Col sm={12}>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginTop: '2rem',
                                    marginBottom: '10px'
                                }}
                            >
                                <h4 style={{ margin: 0 }}>
                                    <b>Alerts Created</b> - {
                                        this.state.createdAlerts
                                            ? this.state.createdAlerts.filter(
                                                a => a.cdiAlertWorkflowID > 0
                                            ).length
                                            : 0
                                    } alerts for {this.props.memberCount} members
                                </h4>
                                {this.renderEditControls('alert')}
                            </div>
                            <BootstrapTable
                                className="package-review-table"
                                data={this.getFilteredAlerts()}
                                multiColumnSort={3}
                                maxHeight="300px"
                                scroll-top="Top"
                                hover
                                selectRow={
                                    this.isViewOnly()
                                        ? undefined
                                        : {
                                            mode: 'checkbox',
                                            clickToSelect: false,
                                            selected: this.state.selectedAlertRows.map(
                                                row => row.memberID
                                            ),
                                            onSelect: this.handleAlertRowSelect,
                                            onSelectAll: this.handleAlertSelectAll,
                                            selectAll: true,
                                            bgColor: 'transparent',
                                            unselectable: this.state.createdAlerts
                                                .filter(row => this.isBlankAlert(row))
                                                .map(row => row.memberID)
                                        }
                                }
                            >
                                <TableHeaderColumn dataField='cdiAlertWorkflowID' dataSort dataFormat={this.formatCDIAlertWorkflowLink}>Alert Workflow ID</TableHeaderColumn>
                                <TableHeaderColumn dataField='memberName' dataSort>Member Name</TableHeaderColumn>
                                <TableHeaderColumn dataField='memberID' isKey hidden>Key</TableHeaderColumn>
                                <TableHeaderColumn dataField='memberDOB' dataFormat={this.formatDateString} dataSort>Member DOB</TableHeaderColumn>
                                <TableHeaderColumn dataField='assignedProvider' dataSort>Assigned Provider</TableHeaderColumn>
                                <TableHeaderColumn dataField='appointmentDatetime' dataFormat={this.formatDateString} dataSort hidden={isPrePrint}>Appt. Date</TableHeaderColumn>
                                <TableHeaderColumn dataField='appointmentProvider' dataSort hidden={isPrePrint}>Appt. Provider</TableHeaderColumn>
                                <TableHeaderColumn dataField='altProviderLastName' dataSort hidden={isPrePrint}>Alt. Provider Last</TableHeaderColumn>
                                <TableHeaderColumn dataField='altProviderFirstName' dataSort hidden={isPrePrint}>Alt. Provider First</TableHeaderColumn>
                                <TableHeaderColumn dataField='medicalRecordNumber' dataSort>MRN</TableHeaderColumn>
                                <TableHeaderColumn dataField='alertLineCount' dataSort width='110px'>Alert Line Count</TableHeaderColumn>
                                <TableHeaderColumn dataField='status' dataSort width='150px' dataFormat={this.alertStatusFormatter}>Status</TableHeaderColumn>
                                <TableHeaderColumn dataField='statusDate' dataSort width='150px' dataFormat={(cell, row) => this.isBlankAlert(row) ? '' : this.formatDate(cell)}>Status Date</TableHeaderColumn>
                                <TableHeaderColumn dataField='comments' dataSort width='230px' dataFormat={(cell, row) => this.isBlankAlert(row) ? '' : (cell || '')}>Comments</TableHeaderColumn>
                            </BootstrapTable>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={12}>
                            <div
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginTop: '4rem',
                                    marginBottom: '10px'
                                }}
                            >
                                <h4 style={{ margin: 0 }}>
                                    <b>Queries Included</b>
                                </h4>

                                {this.renderEditControls('query')}
                            </div>
                            <BootstrapTable
                                data={this.getFilteredQueries()}
                                multiColumnSort={3}
                                maxHeight="300px"
                                scroll-top="Top"
                                hover
                                selectRow={
                                    this.isViewOnly()
                                        ? undefined
                                        : {
                                            mode: 'checkbox',
                                            clickToSelect: false,
                                            selected: this.state.selectedQueryRows.map(
                                                row => row.cdiAlertWorkflowID
                                            ),
                                            onSelect: this.handleQueryRowSelect,
                                            onSelectAll: this.handleQuerySelectAll,
                                            selectAll: true
                                        }
                                }
                            >
                                <TableHeaderColumn dataField='cdiAlertWorkflowID' isKey dataSort dataFormat={this.formatCDIAlertWorkflowLink}>Queried Alert Workflow ID</TableHeaderColumn>
                                <TableHeaderColumn dataField='memberName' dataSort>Member Name</TableHeaderColumn>
                                <TableHeaderColumn dataField='memberID' dataSort>Member ID</TableHeaderColumn>
                                <TableHeaderColumn dataField='providerName' dataSort>Appt. Provider</TableHeaderColumn>
                                <TableHeaderColumn dataField='providerID' dataSort>Provider ID</TableHeaderColumn>
                                <TableHeaderColumn dataField='appointmentDatetime' dataFormat={this.formatDateString} dataSort>Appt. Date</TableHeaderColumn>
                                <TableHeaderColumn dataField='numberOfQueries' dataSort># of Query Lines</TableHeaderColumn>
                                <TableHeaderColumn dataField='status' dataSort width='150px' dataFormat={this.statusFormatter}>Status</TableHeaderColumn>
                                <TableHeaderColumn dataField='statusDate' dataSort width='150px' dataFormat={this.statusDateFormatter}>Status Date</TableHeaderColumn>
                                <TableHeaderColumn dataField='comments' dataSort width='230px' dataFormat={this.commentsFormatter}>Comments</TableHeaderColumn>
                            </BootstrapTable>
                        </Col>
                    </Row>

                    {this.props.cbsEnable && (
                        <Row>
                            <Col sm={12}>
                                <h4 style={{ marginTop: '4rem', marginRight: '0.2rem', marginBottom: '1.4rem' }}>
                                    <b>CBS Report List</b>
                                </h4>
                                <BootstrapTable data={this.state.cbsReportList} ref='cbsReportTable' maxHeight="300px" scroll-top="Top" hover>
                                    <TableHeaderColumn dataField='alertId' isKey dataSort>Alert ID</TableHeaderColumn>
                                    <TableHeaderColumn dataField='memberName' dataSort>Member Name</TableHeaderColumn>
                                    <TableHeaderColumn dataField='memberID' dataSort>Member ID</TableHeaderColumn>
                                    <TableHeaderColumn dataField='dateOfServiceFrom' dataSort dataFormat={this.formatDateString}>DOS From</TableHeaderColumn>
                                    <TableHeaderColumn dataField='dateOfServiceTo' dataSort dataFormat={this.formatDateString}>DOS Thru</TableHeaderColumn>
                                    <TableHeaderColumn dataField='providerName' dataSort>Provider Name</TableHeaderColumn>
                                    <TableHeaderColumn dataField='providerNPI' dataSort>Provider NPI</TableHeaderColumn>
                                    <TableHeaderColumn dataField='diagnosisCode' dataSort>Diagnosis Code</TableHeaderColumn>
                                    <TableHeaderColumn dataField='diagnosisDescription' dataSort>Diagnosis Description</TableHeaderColumn>
                                    <TableHeaderColumn dataField='reportStatus' dataSort>Status</TableHeaderColumn>
                                    <TableHeaderColumn dataField='diagCreatedDatetime' dataSort dataFormat={this.formatDateString}>Created Date</TableHeaderColumn>
                                </BootstrapTable>
                            </Col>
                        </Row>
                    )}

                    {this.state.removeDisenrolledMembers &&
                        (

                            <Row style={{ marginBottom: '5rem' }}>
                                <Col sm={12}>
                                    <h4 style={{ marginTop: '4rem', marginBottom: '1.4rem', marginRight: '0.2rem' }}>
                                        <b>Disenrolled members</b>
                                    </h4>
                                    <BootstrapTable data={this.state.disEnrolledMembers} ref='disenrolledTable' multiColumnSort={10} maxHeight="300px" scroll-top="Top"
                                        hover>
                                        <TableHeaderColumn dataField='disEnrollmentDate' dataSort dataFormat={this.formatDateString}>Disenrolled Date</TableHeaderColumn>
                                        <TableHeaderColumn dataField='memberName' dataSort>Member Name</TableHeaderColumn>
                                        <TableHeaderColumn dataField='memberID' isKey dataSort>Member ID</TableHeaderColumn>
                                        <TableHeaderColumn dataField='memberDOB' dataSort dataFormat={this.formatDateString}>Member DOB</TableHeaderColumn>
                                    </BootstrapTable>
                                </Col>
                            </Row>
                        )}
                </Loader>
                <AlertDialog visible={this.state.showPackageDetailsModal} handleModalToggle={this.togglePackageDetailsModal} title={"Package Details"}
                    message={packageDetails} cancelLabel={"Close"} showConfirm={false} renderInnerDiv={true} />
                <AlertDialog visible={this.state.showConfirmFaxModal} handleModalToggle={this.toggleConfirmFaxModal} title={"Fax Alert Package"}
                    message={"Are you sure you want to fax this package?"} handleConfirm={() => this.faxPackage()}
                    confirmLabel={"Confirm"} cancelLabel={"Cancel"} confirmStyle={"success"} glyphicon={"ok"} />
            </div>
        );
    }
}
export default PackageReview;